import { z } from 'zod';

export type AffApiCompany = {
  id: number;
  name: string | null;
  type: 'advertiser' | 'publisher';
  status: 'ACTIVE' | unknown;
  functionalCurrency: 'USD' | unknown;
  companyRole: unknown;
};

export const AffApiCompanySchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  type: z.enum(['advertiser', 'publisher']),
});
